import {AISLE_NAME} from "./Validations";
import {getUTRRegion} from "./Util";

export const getNextAisleName = (aisleName) => {
    const match = aisleName.match(/^([A-Z])(-?)(\d+)$/);
    if (match) {
        const [, letter, separator, number] = match;
        const nextNumber = parseInt(number, 10) + 1;
        return `${letter}${separator}${nextNumber}`;
    }
    return null;
};

export const getNextPortNumber = (numStr) => {
    const num = parseInt(numStr, 10);
    return !isNaN(num) ? num + 1 : null;
}

export const getObjectByIndex = (list, index) => list.find(item => item.index === index);

export const createAisleConfig = (aisleName, portNumber, aisleType, index) => ({
    aisleName,
    portNumber,
    aisleType,
    index
});

export const createNextAisleConfig = (aisle, aisleType) => createAisleConfig(
    getNextAisleName(aisle.aisleName),
    getNextPortNumber(aisle.portNumber),
    aisleType,
    aisle.index + 1
);

export function getAisleName() {
    const region = getUTRRegion();
    if (region === "NA") {
        return AISLE_NAME.NA
    } else if (region === "EU") {
        return AISLE_NAME.EU
    }
    return AISLE_NAME.FE
}

export const createFirstAisleConfig = (aisleType) => createAisleConfig(
    getAisleName(),
    1,
    aisleType,
    1
);

export const getLastAisleConfig = (availableAisles) => {
    return (availableAisles && (availableAisles.length > 0)) ?
        getObjectByIndex(availableAisles, availableAisles.length)
        : null;
}

export const createNextAisleConfigs = (addAislesReq, index) => {
    let aisleConfig = createAisleConfig(
        addAislesReq.startAisleLabel,
        parseInt(addAislesReq.startPortNumber, 10),
        addAislesReq.aisleType,
        index + 1
    );
    const nextAislesConfigList = [aisleConfig];

    for (let i = 1; i < addAislesReq.aisleCount; i++) {
        const nextAisleConfig = createNextAisleConfig(aisleConfig, addAislesReq.aisleType)
        nextAislesConfigList.push(nextAisleConfig)
        aisleConfig = nextAisleConfig
    }
    return nextAislesConfigList;
}

export const isAssetCreated = (assetDetails, macAddress) => {
    if (!assetDetails || !macAddress) {
        return false;
    }
    return macAddress in assetDetails;
};

export const isAssetStatusUpdated = (assetDetails, macAddress) => {
    if (!assetDetails || !macAddress) {
        return false;
    }
    return !(macAddress in assetDetails)
};

export const getSortedData = (devices) => {
    devices && devices.sort((a, b) => {
        if (a.name < b.name) {
            return -1
        } else if (a.name > b.name) {
            return 1
        }
        return 0
    })
    return devices
};



// WEBPACK FOOTER //
// ./src/components/util/LEDControllerUtil.js